import { defineStore } from 'pinia'
import { useStore } from './index'
import { useMyStoreStore } from './myStore'

const defaultItem = {
  id: 0,
  detailId: 0,
  title: '',
  shopName: '',
  openDate: '',
  closeDate: '',
  imageCount: 0,
  images: [],
  advertisements: [],
  productGroups: [],
}

/**
 * 期間
 * @param {object} param
 * @returns {object}
 */
const getDateSystem = (periodStart, periodEnd) => {
  const periodStartStr = FORMATTEDDATE(periodStart, {
    dayWeekLess: true,
  })
  const periodEndStr = FORMATTEDDATE(periodEnd, {
    dayWeekLess: true,
  })

  const date =
    periodStartStr === periodEndStr
      ? [periodEndStr]
      : [periodStartStr, periodEndStr]

  return {
    date,
  }
}

export const useChirashiStore = defineStore('chirashi', {
  state: () => ({
    items: [],
    item: defaultItem,
    makerRecommends: [],
    tablevas: [],
    displayTablevaItems: 6, // タベレバコンテンツ一項目に表示させるスライド数
    page: 1,
    totalPage: null,
    nextChirashiId: null, // 次に表示するチラシID
    activeChirashiId: null, // 現在表示されているチラシID
    activeDetailId: null, // 現在表示されているチラシ詳細ID
    isLoaded: true, // チラシNEXT画面のロードが終わったかどうか
    isTablevasLoaded: true, // タベレバ記事取得が終わったかどうか
    idFromList: null,
    fromFlyer: false,
    shopName: '',
    isBlank: false, // チラシビュアー用
    tablevasAllLoaded: false,
    isViewerComponent: false,
  }),
  
  getters: {
    themeCount: (state) => {
      return state.item?.productGroups.length ?? 0
    },
    activeSlideIndex: (state) => {
      const index = state.items.findIndex(
        item => item.detailId === state.activeDetailId
      )
      return index < 0 ? 0 : index
    },
    topFlyers: (state) => {
      return 0 in state.items
        ? state.items.map(item => {
            const { date } = getDateSystem(item.openDate, item.closeDate)
            return {
              id: item.id,
              shopName: state.shopName,
              detailId: item.detailId,
              issue: item.title,
              image: item.images[0].thumb_image_url,
              date: {
                date,
                type: 1 in date ? '' : 'limit',
              },
            }
          })
        : []
    },
    flyers: (state) => {
      return 0 in state.items
        ? state.items.map(item => {
            const { date } = getDateSystem(item.openDate, item.closeDate)
            return {
              id: item.id,
              shopName: item.shopName,
              detailId: item.detailId,
              issue: item.title,
              image: item.images[0].thumb_image_url,
              date: {
                date,
                type: 1 in date ? '' : 'limit',
              },
            }
          })
        : []
    },
    flyer: (state) => {
      if (0 in state.item) return {}

      const { date } = getDateSystem(state.item.openDate, state.item.closeDate)

      const item = {
        id: state.item.id,
        shopName: state.item.shopName,
        detailId: state.item.detailId,
        issue: null,
        image: state.item.images[0]?.thumb_image_url,
        date: {
          date,
          type: 1 in date ? '' : 'limit',
        },
      }

      return item
    },
    iframFlyers: (state) => {
      return 0 in state.items
        ? state.items.map(item => {
            const { date } = getDateSystem(item.openDate, item.closeDate)
            const obj = {
              id: item.id,
              shopName: item.shopName,
              detailId: item.detailId,
              shopId: item.detailShopId,
              issue: item.title,
              image: item.images[0]?.mini_image_url
                ? item.images[0]?.mini_image_url
                : item.images[0]?.thumb_image_url,
              date: [],
            }
            1 in date
              ? (obj.date = [item.openDate, item.closeDate])
              : 0 in date
              ? (obj.date = [item.closeDate])
              : (obj.date = [])
            return obj
          })
        : []
    },
    recommendsItems: (state) => {
      const myStoreStore = useMyStoreStore()
      return state.makerRecommends.map(item => {
        return {
          id: item.id,
          image: {
            src: item.image,
            alt: item.title,
          },
          name: item.title ? item.title : '',
          maker: item.maker ? item.maker : '',
          isPr: item?.prflag === 1,
          link:
              myStoreStore.utmSource !== null
                ? `/maker-theme/?shop-id=${myStoreStore.activeMyStoreId}&id=${item.id}&utm_source=${myStoreStore.utmSource}`
                : `/maker-theme/?shop-id=${myStoreStore.activeMyStoreId}&id=${item.id}`,
          relatedLink: item.relatedLink??'',
          type: item.type??0,
        }
      })
    },
    themes: (state) => {
      const myStoreStore = useMyStoreStore()
      const shopId = myStoreStore.activeMyStoreId
      const flyerId = state.activeChirashiId
      const detailId = state.activeDetailId
      return state.item.productGroups.map(item => {
        const productGroupId = item.id
        const items =
          0 in item.products
            ? item.products.map(item => {
                const title = item.name || ''
                const jan = item.jan || ''
                const price = item.price || null
                const taxIncluded = (item?.priceSub ?? item.price_sub) || null
                const image = item.image || ''
                const notes = []
                const periodStartStr = item.periodStart
                  ? FORMATTEDDATE(item.periodStart, {
                      dayWeekLess: true,
                    })
                  : null
                const periodEndStr = item.periodEnd
                  ? FORMATTEDDATE(item.periodEnd, {
                      dayWeekLess: true,
                    })
                  : null

                if (
                  periodStartStr &&
                  periodEndStr &&
                  periodStartStr !== periodEndStr
                ) {
                  notes.push(`${periodStartStr}-${periodEndStr}`)
                } else if (periodStartStr) {
                  notes.push(`${periodStartStr}限り`)
                }
                if (item.remark) notes.push(item.remark)
                return {
                  title,
                  jan,
                  price,
                  taxIncluded,
                  image,
                  notes,
                  shopId,
                  flyerId,
                  detailId,
                  productGroupId,
                }
              })
            : []
        const image = item.image || ''
        const headerText = item.title || ''
        const uniqueIdAttribute = `${shopId}-${flyerId}-${detailId}-${productGroupId}`
        const link = `/theme/?shop-id=${shopId}&flyer-id=${flyerId}&detail-id=${detailId}&id=${productGroupId}`
        const linkUtm = `/theme/?shop-id=${shopId}&flyer-id=${flyerId}&detail-id=${detailId}&id=${productGroupId}&utm_source=${myStoreStore.utmSource}`
        const { date } = getDateSystem(item.periodStart, item.periodEnd)
        return {
          headerText,
          image,
          link: myStoreStore.utmSource ? linkUtm : link,
          date: {
            date,
            type: 1 in date ? '' : 'limit',
          },
          items: items.slice(0, 3),
          id: `${productGroupId}`,
          uniqueIdAttribute,
        }
      })
    },
    sliceTablevas: (state) => index => {
      const start = index * state.displayTablevaItems
      const end = start + state.displayTablevaItems
      return state.tablevas.slice(start, end)
    },
    thumbImages: (state) => {
      return state.item.images.map(item => {
        return {
          image: item.thumb_image_url,
          width: item.thumb_image_width,
          height: item.thumb_image_height,
        }
      })
    },
    spImages: (state) => {
      return state.item.images.map(item => {
        return {
          image: item.sp_image_url,
          width: item.sp_image_width,
          height: item.sp_image_height,
        }
      })
    },
    pcImages: (state) => {
      return state.item.images.map(item => {
        return {
          image: item.pc_image_url,
          width: item.pc_image_width,
          height: item.pc_image_height,
        }
      })
    },
    date: (state) => {
      if (state.item.openDate) {
        const { date } = getDateSystem(state.item.openDate, state.item.closeDate)

        return {
          date,
          type: 1 in date ? '' : 'limit',
        }
      } else {
        return null
      }
    },
},

// export const mutations = {
//   clearAll(state) {
//     state.items = []
//     state.item = defaultItem
//     state.tablevas = []
//     state.makerRecommends = []
//     state.totalPage = null
//     state.page = 1
//     state.nextChirashiId = null
//     state.activeChirashiId = null
//     state.activeDetailId = null
//     state.isLoaded = true
//     state.isTablevasLoaded = true
//     state.idFromList = null
//     state.shopName = ''
//     state.fromFlyer = false
//     state.isBlank = false
//     state.tablevasAllLoaded = false
//   },
//   initIframe(state) {
//     state.items = []
//     state.item = defaultItem
//     state.tablevas = []
//     state.makerRecommends = []
//     state.totalPage = null
//     state.page = 1
//     state.nextChirashiId = null
//     state.activeChirashiId = null
//     state.isLoaded = true
//     state.isTablevasLoaded = true
//     state.idFromList = null
//     state.shopName = ''
//     state.fromFlyer = false
//     state.isBlank = false
//     state.tablevasAllLoaded = false
//   },
//   initFlyer(state) {
//     state.items = []
//     state.item = defaultItem
//     state.nextChirashiId = null
//     state.activeChirashiId = null
//     state.activeDetailId = null
//     state.shopName = ''
//   },
//   initTheme(state) {
//     state.item = defaultItem
//   },
//   setItems(state, items) {
//     state.items = items
//   },
//   clearItems(state) {
//     state.items = []
//   },
//   setItem(state, item) {
//     state.item = item
//   },
//   setRecommends(state, item) {
//     state.makerRecommends = item
//   },
//   clearItem(state) {
//     state.item = defaultItem
//   },
//   setTablevas(state, tablevas) {
//     state.tablevas = [...state.tablevas, ...tablevas]
//   },
//   setTotalPage(state, totalPage) {
//     state.totalPage = totalPage
//   },
//   setPage(state, page) {
//     state.page = page
//   },
//   setNextChirashiId(state, id) {
//     state.nextChirashiId = id
//   },
//   setActiveChirashiId(state, id) {
//     state.activeChirashiId = id
//   },
//   setActiveDetailId(state, id) {
//     state.activeDetailId = id
//   },
//   setIsLoaded(state, flag) {
//     state.isLoaded = flag
//   },
//   setIsTablevasLoaded(state, flag) {
//     state.isTablevasLoaded = flag
//   },
//   setIdFromList(state, id) {
//     state.idFromList = id
//   },
//   setShopName(state, shopName) {
//     state.shopName = shopName
//   },
//   clearIdFromList(state) {
//     state.idFromList = null
//   },
//   setFromFlyer(state, value) {
//     state.fromFlyer = value
//   },
//   clearFromFlyer(state) {
//     state.fromFlyer = false
//   },
//   setdisplayTablevaItems(state, value) {
//     state.displayTablevaItems = value
//   },
//   setIsBlank(state, value) {
//     state.isBlank = value
//   },
//   setTablevasAllLoaded(state, value) {
//     state.tablevasAllLoaded = value
//   },
// },

  actions: {
    async fetchItems({ shopId, detailId }) {
      const rootStore = useStore()
      const runtimeConfig = useRuntimeConfig()
      await POST('get_flyer_list', {
        body: {
          clientKey: runtimeConfig.public.clientKey,
          mediaId: rootStore.mediaId,
          chainId: rootStore.chainId,
          accessToken: rootStore.accessToken,
          impressionKey: rootStore.user.impressionKey,
          shopId,
          reqTime: UNIXTIMESTAMP(),
        },
      })
        .then(res => {
          const items = res.data.items
          const shopName = res.data.shopName
          if (detailId) {
            const detailIndex = items.findIndex(
              item => item.detailId === detailId
            )
            if (detailIndex < 0) {
              const error = new Error('does not exist')
              error.data = {
                error: {
                  errorCode: 404,
                  errorMessage: 'page not found',
                },
              }
              error.status = 404
              throw error
            }
            this.activeChirashiId = items[detailIndex].id
            this.nextChirashiId = items[detailIndex].id
          }
          if (items.length === 0) {
            return
          }

          if (!this.activeChirashiId && items[0]) {
            this.activeChirashiId = items[0].id
            this.nextChirashiId = items[0].id
          }
          if (!this.activeDetailId && items[0]) {
            this.activeDetailId = items[0].detailId
          }
          this.items = items
          this.shopName = shopName
        })
        .catch(err => {
          const status = err.status
          const error = err.data.error.errorCode
          // アクセストークンが期限切れ
          if (status === 401 && error === '10001') {
            rootStore.refreshTokens()
          } else {
            return Promise.reject(err)
          }
        })
    },
    async fetchIframeItems({ shopCode }) {
      const rootStore = useStore()
      const runtimeConfig = useRuntimeConfig()
      await POST('get_flyer_list', {
        body: {
          clientKey: runtimeConfig.public.clientKey,
          mediaId: rootStore.mediaId,
          chainId: rootStore.chainId,
          impressionKey: rootStore.user.impressionKey,
          shopCode,
          reqTime: UNIXTIMESTAMP(),
        },
      })
        .then(res => {
          const items = res.data.items
          const shopName = res.data.shopName
          if (items.length === 0) {
            return
          }
          this.items = items
          this.shopName = shopName
        })
        .catch(err => {
          const status = err.status
          const error = err.data.error.errorCode
          // アクセストークンが期限切れ
          if (status === 401 && error === '10001') {
            rootStore.refreshTokens()
          } else {
            return Promise.reject(err)
          }
        })
    },
    async fetchItem({ shopId, id, detailId, keepAdvertisements }) {
      // console.log(`shopId:${shopId}, id: ${id}, detailId: ${detailId}`)
      const rootStore = useStore()
      const runtimeConfig = useRuntimeConfig()
      await POST('get_flyer_detail', {
        body: {
          clientKey: runtimeConfig.public.clientKey,
          mediaId: rootStore.mediaId,
          chainId: rootStore.chainId,
          shopId,
          id,
          detailId,
          accessToken: rootStore.accessToken,
          impressionKey: rootStore.user.impressionKey,
          reqTime: UNIXTIMESTAMP(),
        },
      })
        .then(res => {
          const item = res.data
          this.item = item
        })
        .catch(err => {
          const status = err.status
          const error = err.data.error.errorCode
          // アクセストークンが期限切れ
          if (status === 401 && error === '10001') {
            rootStore.refreshTokens()
          } else {
            return Promise.reject(err)
          }
        })
    },
    async fetchRecommends({ shopId }) {
      const rootStore = useStore()
      const runtimeConfig = useRuntimeConfig()
      await POST('get_advertisement_list', {
        body: {
          clientKey: runtimeConfig.public.clientKey,
          mediaId: rootStore.mediaId,
          chainId: rootStore.chainId,
          shopId,
          display: 'flyer',
          count: 3,
          accessToken: rootStore.accessToken,
          impressionKey: rootStore.user.impressionKey,
          reqTime: UNIXTIMESTAMP(),
        },
      })
        .then(res => {
          const advertisements = res.data.advertisements
          this.makerRecommends = advertisements
        })
        .catch(err => {
          const status = err.status
          const error = err.data.error.errorCode
          // アクセストークンが期限切れ
          if (status === 401 && error === '10001') {
            rootState.refreshTokens()
          } else {
            return Promise.reject(err)
          }
        })
    },
    async fetchTablevaContents({ page }) {
      const rootStore = useStore()
      const myStoreStore = useMyStoreStore()
      const runtimeConfig = useRuntimeConfig()
      if (this.activeChirashiId !== this.nextChirashiId) {
        this.activeChirashiId = this.nextChirashiId
        return
      }
      if (this.totalPage && this.totalPage < page) {
        this.tablevasAllLoaded = true
        return
      }
      if (this.tablevasAllLoaded) {
        return
      }
      if (this.totalPage === 0) {
        return
      }
      this.isTablevasLoaded = false

      const data = {
        clientKey: runtimeConfig.public.clientKey,
        mediaId: rootStore.mediaId,
        chainId: 0,
        accessToken: rootStore.accessToken,
        impressionKey: rootStore.user.impressionKey,
        page,
        reqTime: UNIXTIMESTAMP(),
        sort: 9,
        isFlyerLink: 1,
        shopChainId: rootStore.chainId,
      }

      if (myStoreStore.activeMyStoreId) {
        data.shopCode = myStoreStore.activeMyStoreId
      }

      await POST('get_content_list', {
        body: data,
      })
        .then(res => {
          const resData = res.data
          const items = resData.items.map(item => {
            return {
              id: item.id,
              name: item.title,
              image: {
                alt: item.title,
                src: item.mainImage,
                width: item.listImageAttribute.width,
                height: item.listImageAttribute.height,
              },
              link: `/content/${item.id}`,
              pr: item.prflag === 1,
            }
          })
          const totalPage = resData.totalPage
          this.tablevas = [...this.tablevas, ...items]
          this.totalPage = totalPage
          this.page = page
          this.isTablevasLoaded = true
          this.fetchTablevaContents({ page: this.page + 1})
        })
        .catch(err => {
          const status = err.status
          const error = err.data.error.errorCode
          // アクセストークンが期限切れ
          if (status === 401 && error === '10001') {
            rootStore.refreshTokens()
          } else {
            return Promise.reject(err)
          }
        })
    },
    clearAll() {
      this.items = []
      this.item = defaultItem
      this.tablevas = []
      this.makerRecommends = []
      this.totalPage = null
      this.page = 1
      this.nextChirashiId = null
      this.activeChirashiId = null
      // this.activeDetailId = null
      this.isLoaded = true
      this.isTablevasLoaded = true
      this.idFromList = null
      this.shopName = ''
      this.fromFlyer = false
      this.isBlank = false
      this.tablevasAllLoaded = false
    },
    initIframe() {
      this.items = []
      this.item = defaultItem
      this.tablevas = []
      this.makerRecommends = []
      this.totalPage = null
      this.page = 1
      this.nextChirashiId = null
      this.activeChirashiId = null
      this.isLoaded = true
      this.isTablevasLoaded = true
      this.idFromList = null
      this.shopName = ''
      this.fromFlyer = false
      this.isBlank = false
      this.tablevasAllLoaded = false
    },
    initFlyer() {
      this.items = []
      this.item = defaultItem
      this.nextChirashiId = null
      this.activeChirashiId = null
      this.activeDetailId = null
      this.shopName = ''
    },
    initTheme() {
      this.item = defaultItem
    },
    clearItem() {
      this.item = defaultItem
    }
  }
})